import React from 'react'

import PropTypes from 'prop-types'

import * as S from './styled'

const SectionWrapper = ({ className, children, ...props }) => (
  <S.SectionWrapper className={`${className} section-wrapper`} {...props}>
    {children}
  </S.SectionWrapper>
)

SectionWrapper.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  noPadding: PropTypes.bool,
  marginTop: PropTypes.number,
  paddingTop: PropTypes.number,
  paddingBottom: PropTypes.number,
  paddingLeft: PropTypes.number,
  paddingRight: PropTypes.number,
  bgColor: PropTypes.string,
  bgGradient: PropTypes.array,
  zindexAfter: PropTypes.number,
  bottom: PropTypes.number,
  beforeSkew: PropTypes.oneOf(['to-left', 'to-right']),
  beforeSkewInvert: PropTypes.oneOf(['to-left', 'to-right']),
  afterSkew: PropTypes.oneOf(['to-left', 'to-right']),
  afterSkew30: PropTypes.oneOf(['to-left', 'to-right'])
}

export default SectionWrapper
